import { A as IS_CHECKING_OUT, B as CART_PAGE_CLASSNAME, F as PRODUCT_PAGE_CLASSNAME } from './built-constants-439d5572.js';
import { s as scriptsConfig } from './built-config-a65ae98c.js';
import { l as log } from './built-loglevel-42c63e3e.js';
import { g as getObjectFromSessionStorage, r as removeItemFromSessionStorage, s as setObjectInSessionStorage } from './built-storage-042e9783.js';

// @ts-check
const {
  SELECTORS: {
    CART
  }
} = scriptsConfig;
/**
 * Sets a flag indicating that a checkout has been initiated
 * @param {String} [url] - A URL may be passed in, or will be obtained at the
 * time the function is called
 */

const setCheckingOutFlag = (url = window.location.href) => setObjectInSessionStorage(IS_CHECKING_OUT, {
  time: new Date().getTime(),
  url
});
/**
 * Track checkout events, event types
 * @param {Object} [metadata]
 * @param {String} [metadata.checkoutType]
 * @param {String} [metadata.message]
 * @param {Error} [error]
 */

const trackCheckout = (metadata, error = null) => {
  if (error) {
    error.stack = error.stack + "\n" + JSON.stringify(metadata) + "}.";
    return console.error(error);
  }

  log.debug(metadata);
};
/**
 * Get the JSON-parsed value of the checking-out flag that may be set in
 * `sessionStorage`
 * @param {String} key
 * @returns {String | null | undefined}
 */

const getCheckingOutFlagValue = key => {
  const checkingOutObj = getObjectFromSessionStorage(IS_CHECKING_OUT);
  return checkingOutObj == null ? void 0 : checkingOutObj[key];
};
/**
 * Gets the time from when the "checkout started" flag was set
 * @returns {String | undefined}
 */


const getCheckingOutFlagTime = () => getCheckingOutFlagValue('time');
/**
 * Gets the url from when the "checkout started" flag was set
 * @returns {String | undefined}
 */

const getCheckingOutFlagURL = () => getCheckingOutFlagValue('url');
/**
 * Unsets a flag indicating that a checkout has been initiated
 */

const unsetCheckingOutFlag = () => removeItemFromSessionStorage(IS_CHECKING_OUT);
/**
 * Asserts the user has landed back on the cart or a product page and the
 * checking-out flag was not unset by checkout. This indicates that this was a
 * redirect back from checkout (which always returns to the cart page) or other
 * failure to check out
 * @returns {Boolean}
 */

const wasFailedCheckout = () => {
  const bodyClassList = document.body.classList;
  const isCartOrProductPage = bodyClassList.contains(CART_PAGE_CLASSNAME) || bodyClassList.contains(PRODUCT_PAGE_CLASSNAME);
  return getObjectFromSessionStorage(IS_CHECKING_OUT) && isCartOrProductPage;
};
/**
 * Pass a callback to be called on checkout (the cart form submit event)
 * @param {(this: HTMLFormElement, event: Event) => void} callback
 * @returns {Function} Function to call to remove the delegated event listener
 */

const onCheckout = callback => {
  /** @param {Event} e */
  const submitListener = function submitListener(e) {
    const form =
    /** @type {HTMLFormElement} */
    e.target;
    /**
     * Verify that the event came from a cart form.
     * This is necessary because the listener is attached to the document,
     * and the form may not exist on page load.
     */

    if (!form.closest(CART)) return;

    callback.call(form, e);
  }; // Attaching a listener to document so we can receive events
  // for forms that didn't exist on page load


  document.addEventListener('submit', submitListener); // Return a function that can remove the event listener

  return () => document.removeEventListener('submit', submitListener);
};

export { getCheckingOutFlagURL as a, getCheckingOutFlagTime as g, onCheckout as o, setCheckingOutFlag as s, trackCheckout as t, unsetCheckingOutFlag as u, wasFailedCheckout as w };
